/**
 * StarArrow SDK Loader
 * This script is the entry point for the SDK. It reads configuration from
 * data attributes and loads the main SDK bundle dynamically.
 */

(function() {
  // Find our own script tag
  const currentScript = document.currentScript as HTMLScriptElement;

  if (!currentScript) {
    console.error('StarArrow SDK: Could not find script tag');
    return;
  }

  // Extract configuration from data attributes
  const apiKey = currentScript.getAttribute('data-api-key');

  // Determine API endpoint based on where SDK is hosted
  let apiEndpoint = currentScript.getAttribute('data-api-endpoint');

  if (!apiEndpoint) {
    // Auto-detect endpoint based on SDK source
    const scriptSrc = currentScript.src;
    console.log('🔍 scriptSrc:', scriptSrc);

    if (scriptSrc.includes('stararrow-sdk-prod.vercel.app') ||
        scriptSrc.includes('stararrow-sdk-prod.vercel.app') || scriptSrc.includes('cdn.stararrow.ai')) {
      // Production SDK - use production server
      apiEndpoint = 'wss://api.stararrow.ai';
    } else if (scriptSrc.includes('localhost:10002')) {
      // Local development
      apiEndpoint = 'ws://localhost:10001';
    } else {
      // Fallback to default
      apiEndpoint = 'wss://api.stararrow.ai';
    }
  }

  const autoInit = currentScript.getAttribute('data-auto-init') !== 'false';
  const debug = currentScript.getAttribute('data-debug') === 'true';

  // Additional optional configurations
  const theme = currentScript.getAttribute('data-theme') || 'light';
  const position = currentScript.getAttribute('data-position') || 'bottom-right';
  const primaryColor = currentScript.getAttribute('data-primary-color');
  const language = currentScript.getAttribute('data-language') || 'en';

  if (!apiKey) {
    console.error('StarArrow SDK: Missing required data-api-key attribute');
    return;
  }

  // Create the configuration object on window
  window.StarArrowConfig = {
    apiKey,
    apiEndpoint,
    autoInit,
    debug,
    theme,
    position,
    primaryColor,
    language
  };

  // Log configuration in debug mode
  if (debug) {
    const wasAutoDetected = !currentScript.getAttribute('data-api-endpoint');
    console.log('StarArrow SDK: Loading with configuration:', {
      ...window.StarArrowConfig,
      endpointAutoDetected: wasAutoDetected
    });
    if (wasAutoDetected) {
      console.log('StarArrow SDK: Auto-detected endpoint from script source');
    }
  }

  // Determine the SDK bundle URL
  // In production, this would be a CDN URL
  // In development, we use a relative path
  const scriptSrc = currentScript.src;
  const baseUrl = scriptSrc.substring(0, scriptSrc.lastIndexOf('/'));

  let sdkBundleUrl: string;

  // Check if we're in development (loader.ts) or production (loader.js)
  if (scriptSrc.endsWith('loader.ts')) {
    // Development mode - load the main index.ts through Vite
    sdkBundleUrl = baseUrl + '/index.ts';
  } else if (scriptSrc.endsWith('loader.js')) {
    // Production mode - load the compiled IIFE bundle
    sdkBundleUrl = baseUrl + '/stararrow-sdk.iife.js';
  } else {
    // Fallback for other environments
    sdkBundleUrl = baseUrl + '/stararrow-sdk.iife.js';
  }

  // Create and inject the main SDK script
  const sdkScript = document.createElement('script');
  sdkScript.type = 'module';
  sdkScript.src = sdkBundleUrl;
  sdkScript.async = true;

  // Add error handling
  sdkScript.onerror = function() {
    console.error('StarArrow SDK: Failed to load main bundle from', sdkBundleUrl);
  };

  sdkScript.onload = function() {
    if (debug) {
      console.log('StarArrow SDK: Main bundle loaded successfully');
    }
  };

  // Append to head or body
  const target = document.head || document.body;
  target.appendChild(sdkScript);

  // Set a flag to indicate the loader has run
  window.__stararrowLoaderExecuted = true;
})();

// TypeScript declarations for the window object
declare global {
  interface Window {
    StarArrowConfig?: {
      apiKey: string;
      apiEndpoint: string;
      autoInit: boolean;
      debug: boolean;
      theme: string;
      position: string;
      primaryColor?: string;
      language: string;
    };
    __stararrowLoaderExecuted?: boolean;
  }
}